import dynamic from 'next/dynamic';

/**
 * This dynamically imports `RegistrationStatusForm` content at the lazily when required.
 * This helps prevent nextjs hydration errors.
 */
export const DynamicTouchScreenCanvasTest = dynamic(
  () => import('./TouchScreenCanvasTest')
);

DynamicTouchScreenCanvasTest.displayName = 'DynamicTouchScreenCanvasTest';
